import refs from '../helpers/refs'

class CProductGrid {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    if (this.$refs.showModal) {
      this.$refs.showModal.addEventListener('click', () => {
        this.showModal()
      })
    }

    // Pagination controls can be absent if not needed
    if (this.$refs.paginationControl) {
      // Ensure that pagination control ref is always an array
      if (!Array.isArray(this.$refs.paginationControl)) {
        this.$refs.paginatonControl = [this.$refs.paginationControl]
      }
    }

    if (this.$refs.clearFiltersAlt) {
      this.$refs.clearFiltersAlt.addEventListener('click', () => {
        this.clearFilters()
      })
    }

    if (this.$refs.toggleFilters) {
      this.$refs.toggleFilters.addEventListener('click', () => {
        this.toggleFilters()
      })
    }
  }

  clearFilters () {
    const event = new CustomEvent('cFilters:clearFilters')
    document.dispatchEvent(event)
  }

  showModal () {
    const event = new CustomEvent('cFilters:showModal')
    document.dispatchEvent(event)
  }

  toggleFilters () {
    this.$root.classList.toggle('--wide')
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-product-grid')
    .forEach(el => new CProductGrid(el))
})
